var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "h2",
        {
          staticClass:
            "text-brown-400 font-extraBold text-30 mb-[25px] lg:mb-50"
        },
        [_vm._v("Ik solliciteer als")]
      ),
      _vm._v(" "),
      _c("form-base", {
        ref: "form",
        staticClass:
          "job-application-form grid grid-cols-1 lg:grid-cols-2 lg:gap-y-[19px] lg:gap-x-[50px] h-full lg:h-auto",
        attrs: { id: _vm.formId ? _vm.formId : "" },
        on: { submit: _vm.submit },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var invalid = ref.invalid
              var loading = ref.loading
              var success = ref.success
              return [
                _c("form-select", {
                  staticClass: "col-span-1 lg:col-span-2 text-brown-400 ",
                  attrs: {
                    placeholder: "Selecteer jouw statuut",
                    options: ["Bediende", "Jobstudent", "Stagiair"]
                  },
                  model: {
                    value: _vm.payload.statuut,
                    callback: function($$v) {
                      _vm.$set(_vm.payload, "statuut", $$v)
                    },
                    expression: "payload.statuut"
                  }
                }),
                _vm._v(" "),
                _c("form-input", {
                  staticClass: "col-span-1",
                  attrs: {
                    name: "first_name",
                    placeholder: "Voornaam",
                    rules: "required"
                  },
                  model: {
                    value: _vm.payload.first_name,
                    callback: function($$v) {
                      _vm.$set(_vm.payload, "first_name", $$v)
                    },
                    expression: "payload.first_name"
                  }
                }),
                _vm._v(" "),
                _c("form-input", {
                  staticClass: "col-span-1",
                  attrs: {
                    name: "last_name",
                    placeholder: "Achternaam",
                    rules: "required"
                  },
                  model: {
                    value: _vm.payload.last_name,
                    callback: function($$v) {
                      _vm.$set(_vm.payload, "last_name", $$v)
                    },
                    expression: "payload.last_name"
                  }
                }),
                _vm._v(" "),
                _c("form-input", {
                  staticClass: "col-span-1",
                  attrs: {
                    name: "email",
                    placeholder: "E-mailadres",
                    type: "email",
                    rules: "required|email"
                  },
                  model: {
                    value: _vm.payload.email,
                    callback: function($$v) {
                      _vm.$set(_vm.payload, "email", $$v)
                    },
                    expression: "payload.email"
                  }
                }),
                _vm._v(" "),
                _c("form-input", {
                  staticClass: "col-span-1",
                  attrs: {
                    name: "phone",
                    placeholder: "Telefoon",
                    rules: "required"
                  },
                  model: {
                    value: _vm.payload.phone,
                    callback: function($$v) {
                      _vm.$set(_vm.payload, "phone", $$v)
                    },
                    expression: "payload.phone"
                  }
                }),
                _vm._v(" "),
                !["sm", "md", "lg"].includes(_vm.$root.$mq)
                  ? _c("form-input", {
                      staticClass: "col-span-1",
                      attrs: {
                        name: "zip",
                        placeholder: "Postcode",
                        rules: "required"
                      },
                      model: {
                        value: _vm.payload.zip,
                        callback: function($$v) {
                          _vm.$set(_vm.payload, "zip", $$v)
                        },
                        expression: "payload.zip"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !["sm", "md", "lg"].includes(_vm.$root.$mq)
                  ? _c("form-input", {
                      staticClass: "col-span-1",
                      attrs: {
                        name: "city",
                        placeholder: "Gemeente",
                        rules: "required"
                      },
                      model: {
                        value: _vm.payload.city,
                        callback: function($$v) {
                          _vm.$set(_vm.payload, "city", $$v)
                        },
                        expression: "payload.city"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("form-textarea", {
                  staticClass: "col-span-1 lg:col-span-2",
                  attrs: {
                    "label-class": "hidden",
                    name: "motivation",
                    label: "Motivatie",
                    placeholder:
                      "Omschrijf in maximaal drie zinnen waarom jij de geknipte persoon bent voor deze job!",
                    rules: "required"
                  },
                  model: {
                    value: _vm.payload.motivation,
                    callback: function($$v) {
                      _vm.$set(_vm.payload, "motivation", $$v)
                    },
                    expression: "payload.motivation"
                  }
                }),
                _vm._v(" "),
                !["sm", "md", "lg"].includes(_vm.$root.$mq)
                  ? _c("form-file", {
                      staticClass: "col-span-1 lg:col-span-2 h-[250px]",
                      attrs: {
                        name: "upload",
                        required: true,
                        placeholder: "Upload hier je CV, motivatiebrief, ..."
                      },
                      model: {
                        value: _vm.payload.files,
                        callback: function($$v) {
                          _vm.$set(_vm.payload, "files", $$v)
                        },
                        expression: "payload.files"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "mt-24" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.termsAccepted,
                        expression: "termsAccepted"
                      }
                    ],
                    attrs: { type: "checkbox", id: _vm._uid, required: "true" },
                    domProps: {
                      checked: Array.isArray(_vm.termsAccepted)
                        ? _vm._i(_vm.termsAccepted, null) > -1
                        : _vm.termsAccepted
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.termsAccepted,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.termsAccepted = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.termsAccepted = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.termsAccepted = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "text-brown-400", attrs: { for: _vm._uid } },
                    [
                      _vm._v("Ik heb de "),
                      _c(
                        "a",
                        {
                          staticClass: "underline",
                          attrs: { href: "/privacybeleid" }
                        },
                        [_vm._v("gebruiksvoorwaarden")]
                      ),
                      _vm._v(" gelezen en ga akkoord.")
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("form-error", {
                  staticClass: "col-span-1 lg:col-span-2",
                  attrs: { "error-response": _vm.errorResponse }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex col-span-1 lg:col-span-2 items-center  gap-32"
                  },
                  [
                    _c(
                      "form-submit",
                      {
                        staticClass:
                          "w-full mt-32 lg:mt-0 md:w-auto whitespace-nowrap",
                        attrs: {
                          disabled: invalid || !_vm.termsAccepted,
                          loading: loading,
                          success: success
                        }
                      },
                      [_vm._v("verstuur jouw sollicitatie")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "font-bold" }, [
                      _vm._v(_vm._s(_vm.success_message))
                    ])
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }